import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 86D895A6-8B2C-4757-A2CC-C506B402C2BB
 * name arrow-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-bold-outline.svg
 * tags
 * - Arrow 
 * - Automotive 
 */
export const ArrowRightBoldOutlineIcon = createSvgIcon(<><path d="M11,16H3V8H11V2L21,12L11,22V16M13,7V10H5V14H13V17L18,12L13,7Z" /></>, 'ArrowRightBoldOutlineIcon');
export default ArrowRightBoldOutlineIcon